export enum Conditionals {
  NONE = 'none',
  ATTRIBUTES = 'attributes',
  COUNTRY = 'country'
}
